module.exports = __webpack_public_path__ + "img/pageBook.0f20c2ca.png";